<template>
  <Loading v-if="$store.state.isLoading" />
  <div v-else id="app-root">
    <router-view :key="$route.fullPath" />
  </div>


</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import Loading from "./components/Loading";

export default {
  name: 'App',
  components: {
    Loading,
  },
  created() {
    this.$store.dispatch('bootstrapOnCreate');
  },
  destroyed() {
    this.$store.dispatch('cleanupOnDestroy');
  }
}
</script>

<style>
#NOTapp {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
